var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.getPackage != 'premium')?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:('Unlock to PREMIUM plan'),expression:"'Unlock to PREMIUM plan'",modifiers:{"top":true}}],staticClass:"premium",class:{'inline' : _vm.inline == true, 'block': _vm.inline != true}},[_c('i',{staticClass:"fas fa-lock"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-811e00ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PremiumLock.vue
// module id = null
// module chunks = 